// src/Utils/errorHandler.js

import { refreshToken } from '../API';
import { sessionManager } from '../Config/cookies';


// 🔍 استخراج رسالة الخطأ من استجابة الباك إند
const extractErrorMessage = (data) => {
  if (!data) return null;

  // معالجة النصوص والأرقام مباشرة
  if (typeof data === 'string') return data;
  if (typeof data !== 'object') return String(data);

  // إذا كان مصفوفة، نجمع العناصر
  if (Array.isArray(data)) {
    return data
      .map(extractErrorMessage)
      .filter(msg => msg)
      .join(', ');
  }

  // تغطية الحقول الشائعة
  const possibleKeys = [
    'message',
    'message_ar',
    'error',
    'error_message',
    'error_description',
    'detail',
    'msg'
  ];

  for (const key of possibleKeys) {
    if (data[key]) {
      return extractErrorMessage(data[key]);
    }
  }

  // معالجة errors بأسلوب Django REST Framework
  if (data.errors && typeof data.errors === 'object') {
    return Object.values(data.errors)
      .map(extractErrorMessage)
      .filter(msg => msg)
      .join(', ');
  }

  // معالجة non_field_errors (Django)
  if (data.non_field_errors) {
    return extractErrorMessage(data.non_field_errors);
  }

  // 🔑 fallback: إذا كان object فيه مفتاح واحد فقط (مثل data wrapper)
  if (Object.keys(data).length === 1) {
    return extractErrorMessage(Object.values(data)[0]);
  }

  // 🔑 fallback: رجّع كل القيم كنص واحد
  return Object.values(data)
    .map(extractErrorMessage)
    .filter(msg => msg)
    .join(', ');
};

// ⚡️ معالجة أخطاء API
export function handleApiError(error) {

  // إذا كان هناك استجابة من الخادم
  if (error.response?.data) {
    const errorMessage = extractErrorMessage(error.response.data);
    if (errorMessage) {
      return errorMessage;
    }
  }

  // إذا كان هناك رسالة خطأ في error.message
  if (error.message) {
    // تجاهل رسائل axios العامة
    if (!error.message.includes('Network Error') &&
      !error.message.includes('timeout') &&
      !error.message.includes('Request failed')) {
      return error.message;
    }
  }

  // إذا لم يكن هناك استجابة من الخادم
  if (!error.response) {
    return 'فشل في الاتصال بالخادم، يرجى التحقق من اتصال الإنترنت';
  }

  // إذا لم نتمكن من استخراج رسالة خطأ، نعرض رسالة عامة
  return 'حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى';
};

export const handleUnauthorizedError = async (error, originalRequest, axiosInstance) => {
  // إذا لم نكن قد حاولنا تحديث التوكن من قبل
  if (!originalRequest._retry) {
    originalRequest._retry = true;

    try {
      const session = sessionManager.restoreSession();
      const refreshTokenValue = session?.refreshToken;

      if (refreshTokenValue) {

        // طلب تحديث التوكن
        const response = await refreshToken(refreshTokenValue);

        // تحديث التوكنز في الكوكيز
        sessionManager.saveSession({
          access: response.access,
          refresh: response.refresh,
          user: session.userData
          // refresh: response.refreshTokenValue  بس خلصتي جربي هي وشوفي وين المشكلة
        });

        // إعادة الطلب الأصلي مع التوكن الجديد
        originalRequest.headers.Authorization = `Bearer ${response.access}`;

        return axiosInstance(originalRequest);
      }
    } catch (refreshError) {
      handleRefreshTokenFailure();
    }
  }

  // إذا فشل التحديث أو تمت المحاولة من قبل
  handleRefreshTokenFailure();
  return Promise.reject(error);
};

// معالجة فشل تحديث التوكن
export const handleRefreshTokenFailure = () => {
  sessionManager.clearSession();

  // إرسال حدث لحذف الجلسة
  window.dispatchEvent(new CustomEvent('sessionExpired'));
};

// معالجة أخطاء عامة
export const handleError = (error) => {

  if (error.response?.status === 401) {
    handleRefreshTokenFailure();
  }

  return Promise.reject(error);
};


